import { Segment } from './styles';

import { CopyLocale } from '@/services/lifecycleAPI';

type Props = { locale: CopyLocale; onChange: (locale: CopyLocale) => void };

const LocaleSwitch = ({ locale, onChange }: Props) => (
  <Segment role="group" aria-label="Language" data-testid="copyLocaleSwitch">
    <button
      type="button"
      aria-pressed={locale === 'en'}
      onClick={() => onChange('en')}
    >
      English
    </button>
    <button
      type="button"
      aria-pressed={locale === 'es'}
      onClick={() => onChange('es')}
    >
      Spanish
    </button>
  </Segment>
);

export default LocaleSwitch;
